import React, { PureComponent } from 'react';
import { encodeForURI } from 'appSrc/utils';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import AspectRatio from 'react-aspect-ratio';
import TextTruncate from 'react-text-truncate';
import LazyImage from 'appSrc/components/Lazy/Image';
import Like from 'appSrc/components/Like';
import { PrimaryButton, ExternalLink, TruncateBlock, DLRichTextOutput } from 'appSrc/components/UI';
import { fixCurrency, convertImage } from 'appSrc/utils/random';
import { parseYouTubeUrl } from 'appSrc/utils/video';
import { Mixpanel } from 'appSrc/components/Analytics/Mixpanel';
import { ReviewSubcard } from './Subcard';
import TheaterPlayIcon from 'appSrc/components/Shards/Theater/NewPlayIcon';
import style from './styles/style.module.css';

class ExplodingProductCard extends PureComponent {
    constructor( props ) {
        super( props );
        this.state = { mounted: false };
    }
    componentDidMount() {
        this.setState( { mounted: true } );
    }
    trackPurchase = () => {
        var product = this.props.product;
        var retailer = /^(?:https?:\/\/)?([^\/\?\:]+)/.exec( product.originalUrl );
        var likes = !product.likes ? 0 : parseInt( product.likes );
        Mixpanel.track( 'productPurchased', {
            id: product.desireid,
            name: product.title,
            price: product.price,
            retailer: retailer[1] || retailer[0],
            date_created: product.dateCreated,
            like_count: likes,
            source_url: product.url,
            author: product.userid,
            list: product.listid,
        } );
    }
    convertImage = ( image ) => {
        var size = '/276x276';
        var clientWidth = this._el && this._el.clientWidth;
        if( clientWidth ) {
            if( clientWidth <= 100 ) {
                size = '/100x100';
            } else if( clientWidth <= 200 ) {
                size = '/200x200';
            } else if( clientWidth <= 300 ) {
                size = '/300x300';
            } else if( clientWidth <= 400 ) {
                size = '/400x400';
            } else if( clientWidth <= 500 ) {
                size = '/500x500';
            } else if( clientWidth <= 600 ) {
                size = '/600x600';
            }
        }
        image = convertImage( image, size );
        return image;
    }
    render() {
        const { product } = this.props;
        const retailer = product.originalUrl.replace( /^https?:\/\/(?:[^\.]*\.)?([^\.]*\.[^\/]*).*$/, '$1' );
        const image = this.convertImage( product.image );
        const productUrl = '/app/products/' + product.desireid + '/' + encodeForURI(product.title);

        var movieMetaData = {};

        // display the first available review
        let firstReview = null;
        if ( product.reviews && product.reviews.length > 0 ) {
            firstReview = product.reviews[ 0 ];

            movieMetaData = {
                attached_to: 'review_video',
                attached_id: firstReview.id,
                video_author_id: firstReview.userid,
            };
        }

        return (
            <div className={ `${ style.explodingZone } ${ this.props.className }` } id={ this.props.id }>
                <div className={ style.explodingProductCard }>
                    <div className={ style.cardTop }>
                        <div className={ style.imageCard }>
                            <ExternalLink className={ style.retailer }
                            href={ product.url || product.originalUrl }
                            onClick={ this.trackPurchase } >
                                { retailer }
                            </ExternalLink>
                            <div className={ style.floatWrapper }>
                                <Link to={ productUrl } className={ style.blockLink }>
                                    <AspectRatio ratio='1/1'>
                                        <div className={ style.imageWrapper } ref={ ( el ) => { this._el = el; } } >
                                            { this.state.mounted &&
                                                <LazyImage source={ image } />
                                            }
                                        </div>
                                    </AspectRatio>
                                </Link>
                                { firstReview &&
                                    <TheaterPlayIcon className={ style.playButton } youtubeId={ parseYouTubeUrl( firstReview.video_url ) }
                                    metaData={ movieMetaData } />
                                }
                            </div>
                            { this.props.self.userid !== product.userid &&
                                <div className={ style.likeWrapper }>
                                    <Like
                                    size={ 20 }
                                    type="product"
                                    item={ product }
                                    label='Favorite'
                                    iconStyle={ { color: 'black' } }
                                    onUpdate={ this.props.onLike }/>
                                </div>
                            }
                        </div>

                        <div className={ style.basics }>
                            <Link to={ productUrl } >
                                <div className={ style.price }>${ fixCurrency( product.price ) }</div>
                                <TextTruncate
                                line={ 3 }
                                text={ product.title }
                                title={ product.title }
                                containerClassName={ style.detail }/>
                            </Link>
                        </div>
                    </div>

                    <div className={ style.cardBody }>
                        <Link to={ productUrl } className={ style.blockLink }>
                            <TruncateBlock className={ style.description }>
                                <DLRichTextOutput content={ product.description } />
                            </TruncateBlock>
                        </Link>
                        <ExternalLink className={ style.purchaseLink } to={ product.url }>
                            <PrimaryButton
                            label='Purchase'
                            onClick={ this.trackPurchase }
                            fullWidth />
                        </ExternalLink>
                    </div>

                    { firstReview &&
                        <ReviewSubcard review={ firstReview } className={ style.subCard } />
                    }

                    <Link to={ '/app/products/' + product.desireid + '/' + encodeForURI(product.title) } className={ style.viewProductCard }>
                        See More
                    </Link>
                </div>
            </div>
        );
    }
}
ExplodingProductCard.defaultProps = {
    product: {},
    onLike: response => response,
    id: null,
    className: '',
};
ExplodingProductCard.propTypes = {
    product: PropTypes.object.isRequired,
};

const mapStateToProps = ( state ) => {
    return {
        self: state.self.user,
        screenSize: state.screenSize.width,
    };
};

export default connect( mapStateToProps )( ExplodingProductCard );
